module.exports = __webpack_public_path__ + "img/call_to_action.602a03d7.svg";